"use client";

import { Dialog, DialogTrigger, DialogContent, DialogTitle, DialogDescription, DialogFooter, DialogHeader } from "@/components/ui/dialog";
import { Icons } from "@/components/icons";
import Link from "next/link";
import { Separator } from "@radix-ui/react-select";
import { InputWithButton } from "@/components/input-with-button";
import { absoluteUrl } from "@/lib/utils";
import { MobileShareButton } from "@/components/mobile-share-button";
import { useShareDialog } from '@/components/share-dialog-provider';
import React, { useEffect } from "react";


interface ProfileShareDialogProps {
    slug: string;
    hexColour: string;
    textColour: string;
}

export function ProfileShareDialog({ slug, hexColour, textColour }: ProfileShareDialogProps) {
    const { trigger, resetTrigger } = useShareDialog();
    const dialogRef = React.useRef<HTMLButtonElement | null>(null);

    useEffect(() => {
        if (trigger && dialogRef.current) {
        dialogRef.current.click();
        resetTrigger();
        }
    }, [trigger, resetTrigger]);
    return (
        <div className="fixed top-4 left-4 z-50">
          <Dialog >
            <DialogTrigger ref={dialogRef}>
              <div className="bg-white rounded-full p-2 shadow-[0px_4px_16px_rgba(17,17,26,0.1),_0px_8px_24px_rgba(17,17,26,0.1),_0px_16px_56px_rgba(17,17,26,0.1)]">
                <Icons.ellipsisHorizontal width="24" height="24" fill="#000" />
              </div>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader><span className="font-bold">@{slug}</span></DialogHeader>
                {/* Only show MobileShareButton on mobile devices */}
                <div className="sm:hidden">
                    <MobileShareButton title={"Share this SuperStack"} slug={slug} />
                </div>
                <InputWithButton inputValue={absoluteUrl(slug)} hexColour={hexColour} textColour={textColour} />
                <Separator className="my-4 border"/>
              <DialogTitle>Create your own SuperStack</DialogTitle>
              <DialogDescription>
                Collect and showcase testimonials. Grow your business.
              </DialogDescription>
              {/* Add any additional Dialog components you need here */}
              {/* <DialogFooter> */}
                <div className="flex flex-col space-y-2">
                    <Link style={{ backgroundColor: hexColour, color: textColour }} href="/register" className="px-4 py-2 text-center text-white rounded">
                        Sign up free
                    </Link>
                    <Link style={{ borderColor: hexColour, color: hexColour }} href="/" className="px-4 py-2 text-center text-black border rounded">
                        Find out more
                    </Link>
                    <Link style={{ borderColor: hexColour, color: hexColour }} href="/login" className="px-4 py-2 text-center text-black border rounded">
                        Log in
                    </Link>
                </div>
                {/* </DialogFooter> */}
            </DialogContent>
          </Dialog>
        </div>
      );
}